import { forwardRef } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import {
  type TAccordionHeaderElement,
  type TAccordionHeaderProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import { cn } from "@/ui/lib/utils";

export const AccordionHeader = forwardRef<TAccordionHeaderElement, TAccordionHeaderProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <AccordionPrimitive.Header
      data-component="AccordionHeader"
      ref={ref}
      className={cn("flex", className)}
      {...props}
    />
  ),
);

AccordionHeader.displayName = AccordionPrimitive.Header.displayName;
